module.exports = __webpack_public_path__ + "media/Components/fonts/boldPlay-543d6025dd5c63651d22c72144f60f69.ttf";